<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-container class="mx-0 px-0">
    <div :class="['IM_2_' + this.id]" class="container-im-2-2">
      <img
        id="ballon"
        class="character"
        width="400"
        src="https://cdn.exploreve.fr/content/IM2/BallonDariaLeonErwin.svg"
      />
      <div class="nuage n01"></div>
      <div class="nuage n02"></div>
      <div class="nuage n03"></div>
      <div class="nuage n04"></div>
      <div class="nuage n05"></div>
      <div class="nuage n06"></div>
      <div class="nuage n07"></div>
      <div class="nuage n08"></div>
      <div class="nuage n09"></div>
      <div class="nuage n10"></div>
      <div class="nuage n11"></div>
      <div class="nuage n12"></div>
      <div class="nuage n13"></div>

      <div class="slideshow-container">
        <div class="mySlides slide1">
          <div class="row">
            <div class="col-md-7"></div>
            <div class="col-md-5">
              <div class="left">
                <div class="arrowleft arrowbottom"></div>
                <p>
                  Eh ben ! On dirait que ça fonctionne ! En espérant que ça tienne un peu, c’est quand même des
                  réparations de fortune. Heureusement que vous étiez là pour m’aider à réparer tout ça, sinon on était
                  coincé·es pour un sacré moment.
                </p>
              </div>
              <div class="left">
                <div class="arrowleft"></div>
                <p>
                  Bon, c’est pas pour autant qu’on est complètement tiré·es d’affaire. Si vous avez encore de l'énergie,
                  après le Brouillard, on pourrait s’attaquer aux Fantômes de l'Ennui! Ils continuent de menacer la
                  Troposphère. Comme on est vraiment beaucoup, on pourrait aller faire de la prévention, implanter nos
                  souvenirs joyeux un peu partout pour les empêcher de se multiplier. Par exemple, vous m'aviez dit que
                  vous avez des expériences en camp… scout ? Ou dans la nature ? C’est des moments forts ça non? On peut
                  en faire quelque chose ?
                </p>
              </div>
            </div>
          </div>
          <div class="w-100" style="text-align: center;">
            <div class="button" @click="plusSlides(1)">Suivant</div>
          </div>
        </div>

        <div class="mySlides slide2">
          <div class="row">
            <div class="col-md-4">
              <div class="right">
                <p>
                  Oui c’est sûr ! On a qu’à aller là où on a vécu notre meilleur souvenir de camp, et prendre un peu de
                  temps pour y repenser ! Par exemple, moi c’était à Néauphle-le-Chateau. C’est là que j'ai fait mon
                  premier camp, j'étais louveteau.
                </p>
                <div class="arrowright arrowbottom"></div>
              </div>
              <div class="right">
                <p>
                  Mon souvenir, c’est le dernier soir, c’était l'anniversaire d’un plus grand, Simon. On a fait une
                  grande veillée autour du feu, avec plein de chamallows, plein de bonbons, ça a duré jusqu’à 1h du
                  matin. C'était super !
                </p>
                <div class="arrowright"></div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="left">
                <div class="arrowleft arrowtop"></div>
                <p>Est-ce que tu penses que tu pourrais nous déposer un peu partout Léon, pour faire ça ?</p>
              </div>
            </div>
          </div>
          <div class="w-100" style="text-align: center;">
            <div class="button" @click="plusSlides(1)">Suivant</div>
          </div>
        </div>

        <div class="mySlides slide3">
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-4">
              <div class="left">
                <p>
                  Ah super, moi c’était au Domaine de Viviers par exemple ! Si tu m’y emmènes, je peux essayer de
                  revivre ce moment là-bas !
                </p>
                <div class="arrowleft arrowtop"></div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="left">
                <div class="arrowleft"></div>
                <p>
                  0ui bien sûr, maintenant que le ballon remarche, il n’y a pas de souci. Il faut juste que vous me
                  donniez les lieux précis, avec les coordonnées GPS, que je puisse programmer ça dans mon navigateur de
                  bord !
                </p>
              </div>
            </div>
          </div>
          <div class="w-100" style="text-align: center;">
            <div class="button" @click="plusSlides(1)">Suivant</div>
          </div>
        </div>

        <div class="mySlides slide4">
          <div class="row">
            <div class="col-md-7"></div>
            <div class="col-md-5">
              <div class="left">
                <div class="arrowleft arrowbottom"></div>
                <p>
                  Maintenant, à toi de faire appel à tes meilleurs souvenirs de camp, ou d’un autre moment si tu n’as
                  pas encore vécu de camp !
                </p>
              </div>
              <div class="left">
                <div class="arrowleft"></div>
                <p>
                  Tu vas arriver sur une carte du monde. Dessus, choisis un lieu dans lequel tu as un souvenir de
                  scoutisme. Quand tu es au bonne endroit, double-clique dessus puis donne-nous quelques informations
                  sur ce souvenir. Il sera ensuite ancré dans la Troposphère et tu pourras te ballader parmis les
                  souvenirs de tous les autres explorêveurs et explorêveuses !
                </p>
              </div>
            </div>
          </div>
          <div class="w-100" style="text-align: center;">
            <NextBtn :url="'/immersion02/' + (this.id + 1)" text="Etape suivante" class="button" />
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
// @ is an alias to /src
import NextBtn from "@/components/NextButton";

export default {
  name: "IM_2_2",
  data: function () {
    return {
      id: 3,
      slideIndex: 0
    };
  },
  mounted() {
    this.currentSlide(1);
    this.emitMusic("play", "musiclancementballonrepare");
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    plusSlides(n) {
      this.slideIndex += n;
      this.showSlides();
    },

    currentSlide(n) {
      this.slideIndex = n;
      this.showSlides();
    },

    showSlides() {
      var slides = document.getElementsByClassName("mySlides");
      if (this.slideIndex < 1) {
        this.slideIndex = slides.length;
      }
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      slides[this.slideIndex - 1].style.display = "block";
    }
  },
  components: { NextBtn }
};
</script>

<style scoped lang="scss">
.container-im-2-2 {
  position: relative;
  width: 100vw;
  min-height: 90vh;
  overflow-x: hidden;

  .button {
    position: absolute;
    color: white;
    background-color: #5e2a57;
    font-size: 25px;
    padding: 10px 20px;
    bottom: 6vh;
    right: 13vw;
    z-index: 20;
    border-radius: 5px;
    cursor: pointer;
  }
  .row {
    height: 100%;
  }

  .left,
  .right {
    font-family: "Faune";
    display: table;
    padding: 10px;
    background-color: white;
    border-radius: 5px;
    margin: 20px;
    width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
    width: -moz-max-content; /* Firefox/Gecko */
    width: -webkit-max-content;
  }

  .left {
    padding-left: 0px;
    margin-left: 20px;
    margin-right: auto;
  }

  .right {
    padding-right: 0px;
    margin-right: 10px;
    margin-left: auto;
  }

  .col-md-5,
  .col-md-4 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    z-index: 10;
    height: 80vh;
  }

  p {
    display: table-cell;
    vertical-align: middle;
  }

  .arrowleft {
    position: relative;
    content: "";
    left: -20px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 20px solid white;
    z-index: 5;
  }

  .arrowright {
    position: relative;
    content: "";
    left: 20px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;

    border-left: 20px solid white;
  }
  .arrowbottom {
    margin-top: 70px;
  }
  .arrowtop {
    left: 160px;
    top: -29px;
    transform: rotate(90deg);
  }

  .mySlides {
    display: none;
    height: 500px;
  }

  img.character {
    z-index: 1;
    position: absolute;
  }
  .nuage {
    position: absolute;
    background-color: $light;
    opacity: 0.5;
  }
  @keyframes envol {
    from {
      margin-top: 0;
    }
    to {
      margin-top: 60vh;
    }
  }
  @keyframes float {
    from {
      margin-top: 60vh;
    }
    to {
      margin-top: 65vh;
    }
  }
  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes cloud {
    from {
      margin-right: 0;
    }
    to {
      margin-right: calc(100% + 750px);
    }
  }

  img#ballon {
    top: -120%;
    right: 40%;
    animation: envol 10s normal linear forwards, float 3s 10s infinite alternate ease-in-out;
  }

  .n01 {
    top: 12%;
    right: -750px;
    width: 750px;
    height: 121px;
    border-radius: 60px;
    z-index: 0;
    animation: cloud 50s infinite normal linear;
  }

  .n02 {
    top: 10%;
    right: -750px;
    width: 197px;
    height: 33px;
    border-radius: 15px;
    z-index: 1;
    animation: cloud 20s 10s infinite normal linear;
  }

  .n03 {
    top: 35%;
    right: -750px;
    width: 500px;
    height: 100px;
    border-radius: 72px;
    z-index: 1;
    animation: cloud 30s 3s infinite normal linear;
  }

  .n04 {
    top: 20%;
    right: -750px;
    width: 430px;
    height: 50px;
    border-radius: 31px;
    z-index: 1;
    animation: cloud 40s 15s infinite normal linear;
  }

  .n05 {
    top: 65%;
    right: -750px;
    width: 450px;
    height: 60px;
    border-radius: 72px;
    z-index: 0;
    animation: cloud 35s 6s infinite normal linear;
  }

  .n06 {
    top: 45%;
    right: -750px;
    width: 426px;
    height: 50px;
    border-radius: 72px;
    z-index: 1;
    animation: cloud 30s 9s infinite normal linear;
  }

  .n07 {
    top: 80%;
    right: -750px;
    width: 317px;
    height: 65px;
    border-radius: 31px;
    z-index: 1;
    animation: cloud 30s 17s infinite normal linear;
  }

  .n08 {
    top: 50%;
    right: -750px;
    width: 617px;
    height: 75px;
    border-radius: 60px;
    z-index: 0;
    animation: cloud 60s 25s infinite normal linear;
  }

  .n09 {
    top: 10%;
    right: 750px;
    width: 197px;
    height: 33px;
    border-radius: 15px;
    z-index: 1;
    animation: cloud 20s normal linear forwards;
  }

  .n10 {
    top: 35%;
    right: 200px;
    width: 500px;
    height: 100px;
    border-radius: 72px;
    z-index: 1;
    animation: cloud 30s normal linear forwards;
  }

  .n11 {
    top: 20%;
    right: 300px;
    width: 430px;
    height: 50px;
    border-radius: 31px;
    z-index: 1;
    animation: cloud 40s normal linear forwards;
  }

  .n12 {
    top: 65%;
    right: 120px;
    width: 450px;
    height: 60px;
    border-radius: 72px;
    z-index: 0;
    animation: cloud 35s normal linear forwards;
  }

  .n13 {
    top: 45%;
    right: 550px;
    width: 426px;
    height: 50px;
    border-radius: 72px;
    z-index: 1;
    animation: cloud 30s normal linear forwards;
  }
  .slide1 {
    .left {
      max-width: 30vw;
      opacity: 0;
      animation: appear 2s 9s normal linear forwards;
    }
    .button {
      opacity: 0;
      animation: appear 2s 9s normal linear forwards;
    }
  }
  .slide2 {
    .left,
    .right {
      max-width: 25vw;
      opacity: 0;
      animation: appear 2s normal linear forwards;
    }
    .col-md-4 {
      .left {
        margin-top: 70vh;
      }
    }
  }
  .slide3 {
    .left {
      max-width: 25vw;
      opacity: 0;
      animation: appear 2s normal linear forwards;
    }
    .col-md-4 {
      margin-top: 55vh;
      height: 30vh;
    }
    .col-md-5 {
      margin-top: 5vh;
    }
    .arrowtop {
      left: -30px;
    }
  }
  .slide4 {
    .left {
      max-width: 30vw;
      opacity: 0;
      animation: appear 2s normal linear forwards;
    }
  }
}
</style>
